import { render, staticRenderFns } from "./RecentActivity.vue?vue&type=template&id=280d583e&scoped=true"
import script from "./RecentActivity.vue?vue&type=script&lang=js"
export * from "./RecentActivity.vue?vue&type=script&lang=js"
import style0 from "./RecentActivity.vue?vue&type=style&index=0&id=280d583e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d583e",
  null
  
)

export default component.exports